import { Measurement } from "./Measurement";

export type ChangeRequestSubmission = {
    id: string;
    type: ChangeRequestType;
    employeeId: string;
    employeeAfasId: string;
    employeeName: string;
    employeeEmail: string;
    employeeCompany: string;
    requestDate: string;
    transactionDate: string;
    kilometersNew: Measurement;
    kilometersOld: Measurement;
};

export enum ChangeRequestType {
    ADD = 0,
    EDIT = 1
}
